import React from 'react';
import heroImage from '../assets/JSPN-Website-Hero-Bg-idea-1.0.jpg';

function Hero() {
  return (
    <div className="w-full h-screen">
      <img
        className="top-0 left-0 w-full h-screen object-cover"
        src={heroImage}
        alt=""
      />
      <div className="bg-black/70 absolute top-0 left-0 w-full h-screen" />
      <div className="absolute top-0 w-full h-full flex flex-col justify-center">
        <div class="container  py-16 mx-auto text-center">
          <div class=" mx-auto">
            <h1 class=" text-white text-sm font-semibold lg:text-3xl ">
              Welcome to Jobs For Us, a premier staffing services company that
              specializes in connecting employers with highly skilled and
              motivated immigrant workers from Latin America and the Caribbean.
              Our recruitment process is thorough and efficient, we ensure that
              all our workers are authorized to work in the USA, and that they
              are fully vetted and screened. Contact us today to schedule a
              consultation and learn how we can help you meet your labor needs.
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
